import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {DetailsPageWrapper} from '@/components/ui/details-atoms/DetailsAtoms'
import {AlertCircleIcon, AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useTreatmentRequest} from '@/features/treatment-requests/services/useTreatmentRequest'
import {TreatmentRequestDetailsUrlParams} from '@/features/treatment-requests/types'
import {useURLParsedParams} from '@/hooks/useURLParsedParams'
import {useTranslation} from '@/translations/i18n'
import {resolveResourceForbiddenErrorLabel} from '@/utilities/helpers'
import {AxiosError} from 'axios'
import {Outlet} from 'react-router-dom'

export const TreatmentRequestDetailsRoute = () => {
    const {t} = useTranslation()
    const urlParams = useURLParsedParams(TreatmentRequestDetailsUrlParams)
    const treatmentRequestQuery = useTreatmentRequest(urlParams.success ? urlParams.data.id : undefined)

    if (treatmentRequestQuery.isPending) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <Spinner size={32} style={{placeSelf: 'center'}} />
            </DetailsPageWrapper>
        )
    }
    if (
        !urlParams.success ||
        (treatmentRequestQuery.error instanceof AxiosError && treatmentRequestQuery.error.response?.status == 404)
    ) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:invalid_link')} />
            </DetailsPageWrapper>
        )
    }
    const forbiddenErrorLabel = resolveResourceForbiddenErrorLabel(treatmentRequestQuery.error)
    if (forbiddenErrorLabel) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <NoPermissionBox title={t(forbiddenErrorLabel)} />
            </DetailsPageWrapper>
        )
    }

    if (treatmentRequestQuery.error) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
            </DetailsPageWrapper>
        )
    }

    return urlParams.success ? (
        <Outlet context={{treatmentRequest: treatmentRequestQuery.data}} />
    ) : (
        <ErrorBox title={t('errors:invalid_link')} icon={<AlertTriangleIcon />} />
    )
}
